/** After trip — the post-trip survey state ("Not sent" re-arms the survey) and the
 *  reviews the guest left, with the guest's review page: masked (it lets the holder
 *  review as the guest), revealed on demand and logged. */
import { Stack } from '@mui/material';

import type { BookingRecordStage } from '@/api/bookingRecord';
import type { ViewSection } from '@/features/records/views/types';

import { fieldDisplay, type BookingDisplayContext } from './displays';
import { MaskedLinkReveal } from './MaskedLinkReveal';
import { StagePanel } from './StagePanel';

function Reviews({ c, masked }: { c: BookingDisplayContext; masked: string }) {
  return (
    <Stack spacing={0.5} component="span">
      <span>{fieldDisplay('reviews', c) ?? 'No review yet'}</span>
      <MaskedLinkReveal bookingId={c.detail.id} kind="review" masked={masked} />
    </Stack>
  );
}

export function AfterTripPanel({
  section,
  display,
}: {
  section: ViewSection<BookingRecordStage>;
  display: BookingDisplayContext;
}) {
  const masked = display.detail.reviews?.masked;
  return (
    <StagePanel
      section={section}
      display={display}
      {...(masked ? { displays: { reviews: <Reviews c={display} masked={masked} /> } } : {})}
    />
  );
}
